
const resumeBuilderStyles = (theme) => ({
  embeddedTabRoot: {
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  builderContainer: {
    backgroundColor: 'var(--grey-30)',
    marginTop: 20,
  },
  builderContainerEmbedded: {
    marginTop: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  allResumeBtn: {
    border: `1px solid ${theme.palette.primary.blue.main}`,
    color: theme.palette.primary.blue.main,
  },
  btn: {
    fontSize: 16,
    fontFamily: 'Inter',
    textTransform: 'capitalize',
    height: 40,
    padding: '0px 20px',
    fontWeight: 700,
    transition: 'all 0.2s'
  },
  backIcon: {
    fontSize: '16px !important',
  },
  editingBackground: {
    background: 'url(/assets/resume/background.png)',
    backgroundSize: '100%',
    color: theme.palette.primary.white,
    padding: 32,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  viewPdfBtn: {
    background: theme.palette.primary.white,
    color: theme.palette.primary.blue.main,
    '&:hover': {
      background: theme.palette.primary.white,
      color: theme.palette.primary.blue.main,
    },
  },
  resumeBuilderContents: {
    padding: '30px 15px',
  },
  resumeBuilderContentsEmbedded: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
  resumeTabEmptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 16,
    padding: '48px 24px',
    minHeight: 280,
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: 'var(--grey-30)',
  },
  resumeTabEmptyStateTitle: {
    color: 'var(--primary-deep)',
    fontWeight: 600,
  },
  resumeTabEmptyStateBody: {
    color: 'var(--primary-deep)',
    maxWidth: 520,
    lineHeight: 1.5,
  },
  resumeTabEmptyStateIcon: {
    fontSize: 48,
    color: theme.palette.grey[400],
  },
});

export default resumeBuilderStyles;
